import { url } from "./MongoConstants";

const getTodaysBets = async () => {
    try {
        const server = url;
        const response = await fetch(server + '/api/data/bet/today', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (response.ok) {
            const data = await response.json();
            return(data)
        } else {
            console.log('Failed to get todays bets');
            return('Failed to get todays bets');
        }
    } catch (error) {
        console.error('An error occurred:', error);
        return('An error occurred:', error);
    }
};

export default getTodaysBets;